import Api from 'fou-api'
import VuexErrors from 'src/vuex/modules/errors'
import Errors from 'src/utils/helper/errors'

export default {
  namespaced: true,

  state: {},

  getters: {},

  mutations: {},

  actions: {
    downloadBinaries ({ commit }, submissionId) {
      return new Promise((resolve, reject) => {
        Api.Downloads.getBinariesZip(submissionId)
          .then(resp => {
            resolve(resp.data.url)
          })
          .catch((error) => {
            commit('errors/add', Errors.create(error))
            reject(new Error(error))
          })
      })
    },
    downloadImages ({ commit }, submissionId) {
      return new Promise((resolve, reject) => {
        Api.Downloads.getImagesZip(submissionId)
          .then(resp => {
            resolve(resp.data.url)
          })
          .catch((error) => {
            commit('errors/add', Errors.create(error))
            reject(new Error(error))
          })
      })
    }
  },

  modules: {
    errors: VuexErrors
  }
}
